var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34273 0.310978L3.65686 5.43629L1.65728 3.24907C1.27813 2.83448 0.663386 2.83448 0.284364 3.24907C-0.094788 3.66394 -0.094788 4.33624 0.284364 4.75097L2.9704 7.68906C3.15991 7.89635 3.40845 8 3.65686 8C3.90527 8 4.15381 7.89635 4.34332 7.68906L9.71552 1.81287C10.0948 1.39814 10.0948 0.725709 9.71565 0.311119C9.33663 -0.103612 8.72188 -0.103754 8.34273 0.310978Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0eba7c7bb4144c76579c34a3a8ed2dc1.svg";
export { ForwardRef as ReactComponent };